import {createContext, useContext} from 'react';

export const ErrorAreaContext = createContext<{
  isMobile: boolean;
  isPopupWindow?: boolean;
}>({
  isMobile: false,
  isPopupWindow: false,
});

export const useErrorAreaContext = () => {
  const context = useContext(ErrorAreaContext);

  if (!context) {
    throw new Error('ErrorAreaContext not found');
  }

  return context;
};
